module.exports = __webpack_public_path__ + "img/P10-zh.d1e85033.png";